import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Login from "./components/Login";
import Signup from "./components/Signup";
import UserFeed from "./components/UserFeed";
import Profile from "./components/Profile";
import CreatePost from "./components/createpost";

function App() {
  return (
    <Routes>
      

      {/* Home page */}
      <Route path="/" element={<Home />} />

      {/* Login page */}
      <Route path="/login" element={<Login />} />
       {/* Sihnup page */}
      <Route path="/signup" element={<Signup />} />
      <Route path="/user" element={<UserFeed />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/createpost" element={<CreatePost />} />
    </Routes>
  );
}

export default App;
